var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebookRed = function SvgFacebookRed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 16.04C32 7.186 24.832 0 16 0S0 7.186 0 16.04c0 7.764 5.504 14.228 12.8 15.72V20.851H9.6V16.04h3.2v-4.01c0-3.096 2.512-5.614 5.6-5.614h4v4.812h-3.2c-.88 0-1.6.722-1.6 1.604v3.208h4.8v4.812h-4.8V32c8.08-.802 14.4-7.635 14.4-15.96z",
    fill: "#c00000"
  })));
};
export default SvgFacebookRed;